import React, { useState, useEffect } from 'react';
import Card from '../../components/common/Card/Card';
import Button from '../../components/common/Button/Button';
import LoadingSpinner from '../../components/common/LoadingSpinner/LoadingSpinner';
import { getAllDisputes, addressDispute } from '../../services/disputeService';
import { formatDate } from '../../utils/helpers';
import { useToast } from '../../context/ToastContext';
import styles from '../common/Disputes.module.css';

const AdminDisputes = () => {
  let [disputes, setDisputes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [addressingId, setAddressingId] = useState(null);
  const toast = useToast();

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    try {
      const data = await getAllDisputes();
      setDisputes(data);
    } catch (error) {
      console.error('Error fetching disputes:', error);
      toast.error('Failed to load disputes');
    } finally {
      setLoading(false);
    }
  };

  const handleAddress = async (disputeId) => {
    setAddressingId(disputeId);
    try {
      await addressDispute(disputeId);
      toast.success('Dispute marked as addressed');
      setDisputes(prev => prev.map(d =>
        d.id === disputeId ? { ...d, addressed: true } : d
      ));
    } catch (error) {
      toast.error('Failed to update dispute: ' + error.message);
    } finally {
      setAddressingId(null);
    }
  };

  if (loading) {
    return <div className={styles.loading}><LoadingSpinner /></div>;
  }
  disputes = disputes.filter(d => !d.addressed);
  return (
    <div className={styles.disputesPage}>
      <div className={styles.header}>
        <h1>Disputes & Issues</h1>
      </div>

      <div className={styles.disputesList}>
        {disputes.length === 0 ? (
          <Card>
            <p className={styles.empty}>No disputes have been raised.</p>
          </Card>
        ) : (
          disputes.map(dispute => (
            <Card key={dispute.id} className={styles.disputeCard}>
              <div className={styles.disputeHeader}>
                <div className={styles.disputeMeta}>
                  <h3 className={styles.projectName}>{dispute.project_name}</h3>
                  <div className={styles.raisedBy}>
                    Raised by: {dispute.raised_by_email}
                    <span className={styles.roleBadge}>{dispute.raised_by_role}</span>
                  </div>
                  <span className={styles.date}>{formatDate(dispute.created_at)}</span>
                </div>
                <span className={`${styles.status} ${dispute.addressed ? styles.statusAddressed : styles.statusPending}`}>
                  {dispute.addressed ? 'Addressed' : 'Pending Review'}
                </span>
              </div>

              <div className={styles.disputeBody}>
                {dispute.dispute}
              </div>

              {!dispute.addressed && (
                <div className={styles.adminActions}>
                  <Button
                    onClick={() => handleAddress(dispute.id)}
                    loading={addressingId === dispute.id}
                  >
                    Mark as Addressed
                  </Button>
                </div>
              )}
            </Card>
          ))
        )}
      </div>
    </div>
  );
};

export default AdminDisputes;
